import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { DeliveryForecastProcessCompletions } from '../../features/selfservice/supplier/data'
import i18n from '../../utils/i18n'
import { DelForProcessBodyTemplate } from './DelForProcessBodyTemplate'

export const DelForProcessFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const processSteps: DeliveryForecastProcessCompletions[] = [
    'confirmation',
    'despatchadvice',
    'despatchadvice_with_confirmation',
  ]

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return DelForProcessBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return DelForProcessBodyTemplate(option)
  }

  return (
    <Dropdown
      value={options.value}
      options={processSteps}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchProcessCompletion')}
    />
  )
}
